import { motion } from "framer-motion";
import { Search, Users, CheckCircle } from "lucide-react";
import { fadeIn, staggerContainer } from "@/lib/animations";

export function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-gray-900">
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
      >
        <motion.div 
          variants={fadeIn("up", "tween", 0.2, 1)}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-light text-white">How Vettor.ai Works</h2>
          <p className="mt-4 text-xl text-gray-400">Our AI agent workflow streamlines your recruiting process in three simple steps</p>
        </motion.div>
        
        <div className="relative">
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gray-700 transform -translate-y-1/2 z-0"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Step 1 */}
            <motion.div
              variants={fadeIn("right", "tween", 0.3, 1)}
              className="relative bg-gray-800 p-8 rounded-xl shadow-lg border border-gray-700 hover:bg-gray-750 transition-all duration-300 z-10"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-violet-900/30 text-violet-400 rounded-full mb-6 mx-auto">
                <Search className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-light text-white text-center mb-3">Define Your Needs</h3>
              <p className="text-gray-400 text-center font-light">Share your recruiting workflow challenges and requirements. Our AI learns your specific process and pain points.</p>
            </motion.div>
            
            {/* Step 2 */}
            <motion.div
              variants={fadeIn("up", "tween", 0.4, 1)}
              className="relative bg-gray-800 p-8 rounded-xl shadow-lg border border-gray-700 hover:bg-gray-750 transition-all duration-300 z-10"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-violet-900/30 text-violet-400 rounded-full mb-6 mx-auto">
                <Users className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-light text-white text-center mb-3">Vettor Optimizes Your Process</h3>
              <p className="text-gray-400 text-center font-light">Our AI agents tackle your key pain points - automating outreach, screening, scheduling, and follow-ups to save you countless hours.</p>
            </motion.div>
            
            {/* Step 3 */}
            <motion.div
              variants={fadeIn("left", "tween", 0.5, 1)}
              className="relative bg-gray-800 p-8 rounded-xl shadow-lg border border-gray-700 hover:bg-gray-750 transition-all duration-300 z-10"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-violet-900/30 text-violet-400 rounded-full mb-6 mx-auto">
                <CheckCircle className="w-8 h-8" />
              </div>
              <h3 className="text-xl font-light text-white text-center mb-3">Hiring Facilitated</h3>
              <p className="text-gray-400 text-center font-light">Focus on building relationships while our AI handles the repetitive tasks. Make better hiring decisions with time saved for what matters most.</p>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
